import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import ServiceFilter from '../../filters/ServiceFilter.jsx';
import TenderModeFilter from '../../filters/TenderModeFilter.jsx';
import TxnTypeFilter from '../../filters/TxnTypeFilter2.jsx';
import SettledUnsettledFilter from '../../filters/settled_unsettledFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import IssuerFilter from '../../filters/IssuerFilter.jsx';
import SchemeFilter from '../../filters/SchemeFilter.jsx';
import CardLogoFilter from '../../filters/CardLogoFilter.jsx';
import CityFilter from '../../filters/CityFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import TransactionMediumFilter from '../../filters/TransactionMediumFilter.jsx';
import ProductTypeFilter from '../../filters/ProductTypeFilter.jsx';
import IndustryCategoryFilter from '../../filters/IndustryCategoryFilter.jsx';
import FallBackFilter from '../../filters/FallBackFilter.jsx';
import PosbillFilter from '../../filters/PosbillFilter.jsx';
import PrimIdFilter from '../../filters/PrimIdFilter.jsx';
import SkuFilter from '../../filters/SkuFilter.jsx';
import InternationalDomesticFilter from '../../filters/InternationalDomesticFilter.jsx';
import InstanceFilter from '../../filters/InstanceFilter.jsx';
import TransactionStatusFilter from '../../filters/TransactionStatusFilter.jsx';
import ProcessingCodeFilter from '../../filters/ProcessingCodeFilter.jsx';
import BoBankResponsecodeFilter from '../../filters/BoBankResponsecodeFilter.jsx';
import CiInnoResponsecode from '../../filters/CiInnoResponsecode.jsx';
import BiBankResponsecodeFilter from '../../filters/BiBankResponsecodeFilter.jsx';
import CoInnoResponseCode from '../../filters/CoInnoResponseCode.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('0', '0', '2020-02-01','0');
var LiveTraDumpTable='';

class BtidGapReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            instance_name:"",
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            issuerBankIds:'',
            cityIds:'',
            loading:false,
            is_void: 1,
            cardGradeIDs:'',
            schemeIDs:'',
            cardTypeIDs:'',
            txnissuerIDs:'',
            tenderModeIDs:'',
            txnTypeIDs: '',
            ciutidIds: '',
            slipData:'',
            isSettledIDs: '',
            is_fallback: 0,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            merchant_sku: 0,
            productTypeIDs: '',
            serviceTypeIDs: '',
            object_code:[],
            communicationIdIds:'',
            industryCategoryIds:'',
            isInternational:'',
            is_extra_column: 'no',
            extraColumns:[],
            extra_columns_query:'',
            extra_columns_merchant:'',
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            txn_status:'',
            processing_code:'',
            bank_responsecode:'',
            ci_inno_responsecode:'',
            bi_bank_responsecode:'',
            co_inno_responsecode:'',
            instance_name:''
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        let isExtraColumns = localStorage.is_extra_column;
        if(isExtraColumns==='yes') {
            let column_array=[];
            if(localStorage.extra_columns!='' || localStorage.extra_columns!=undefined) {
                column_array = localStorage.extra_columns.split(",");
            }
            this.setState({
                is_extra_column: isExtraColumns,
                extraColumns:column_array,
                extra_columns_query:localStorage.extra_columns_query,
                extra_columns_merchant:localStorage.extra_columns_merchant
            })

        }

        isReportAccess(AllAccessPermissions, 'btid_gap_report');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        this.get_columns(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'btid_gap_report','sparcs')
    }
    get_columns(object_type, object_code, event) {
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
         if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        this.setState({
            loading:true,
            is_record: true,
            is_exp_button: false
        })
        let tableHeaders=[];
        let tableBody = [];
        let headerList =[];
        axios.post(config.get('API_URL') + '/summaryReport/btid-gap-reports-row', {
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
            mids: merchants,
            cids: chains,
            sids: stores,
            user_id: this.state.user_id,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            console.log("jhjhsgdhsgdh");
            console.log(response.data);
            if(Array.isArray(response.data.data) && response.data.data.length){
                //if (response.data.data != null) {
                const keys = Object.keys(response.data.data[0]);
                //console.log(keys);
                let keyVal='';

                keys.forEach(function (k) {
                    if(k=='id' || k=='latestversion') {
                        keyVal = '';
                    }
                    else{
                        keyVal = k;
                    }
                    tableHeaders.push({
                        sTitle: keyVal,
                        mData: k.replace(/\./g, '\\.')
                        //optionally do some type detection here for render function
                    });
                    tableBody.push({
                        data: k,
                    });
                    headerList.push(k);
                });
                console.log(tableHeaders);
                console.log(tableBody);
                this.setState({
                    loading: false,
                    is_record: true,
                    is_exp_button: true,
                    tableHeaders:tableHeaders,
                    tableBody:tableBody,
                    headerList:headerList
                });
                this._get_filtered_btid_gap_report(tableHeaders, tableBody,headerList,object_type, object_code);
            }else {
                if ($.fn.DataTable.isDataTable('#LiveTraDumpTable')) {
                    $('#LiveTraDumpTable').DataTable().clear().destroy();
                }
                this.setState({
                    is_record: false,
                    loading: false,
                    isChange: false,
                    is_exp_button: false
                });
            }
        });
    }

    downLoadLiveTraReportCheck (e){

        let filters = {
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            ci_utid: this.state.ciutidIds,
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            user_id: this.state.user_id,
            download: 1,
        }
        this.setState({
            filters:filters
        })

        this.refs.downloadAllReport.downLoadReport(filters, '/summary_reports/btid/gap','btid_gap_report',0);

    }

    _get_filtered_btid_gap_report(tableHeaders, tableBody, headerList, object_type, object_code) {
        console.log(tableHeaders);
        console.log(tableBody);
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        var that = this;



        var postData = {
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
            mids: merchants,
            cids: chains,
            sids: stores,
            user_id: this.state.user_id,
        };
        if ($.fn.DataTable.isDataTable('#LiveTraDumpTable')) {
            $('#LiveTraDumpTable').DataTable().clear().destroy();
        }

        LiveTraDumpTable = $('#LiveTraDumpTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": true,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/btid-gap-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },
                "fnDrawCallback": function () {
                    $("#loading").hide();
                    var api = this.api();
                    setTimeout( function () {
                        api.columns().flatten().each(function (colIdx) {
                            var columnData = api.columns(colIdx).data().join('');
                            if (columnData.length == (api.rows().count() - 1) && colIdx != 0) {
                                api.column(colIdx).visible(false);
                            }
                        });
                    },0)
                },
                aoColumns:tableHeaders,
                columns: tableBody,

            });


    }
    hideEmptyColumns(table){ alert("hi")
        table.columns().every( function () {
        var column = this;
        // Check if all cells in column are empty
        if ( $.trim( column.data().join('') ) === '' ) {
          // Hide the column
          column.visible( false );
        }
        });
    }
    reset_all(e){
        //this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
//             this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
//             this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');

        }

        if(this.state.object_type==='Innoviti')
        {

            this.refs.reloadUtid.ci_utid('','','',false,'');
        }



        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            ciutidIds: '',
        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });

    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }



    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Btid Gap Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this._get_filtered_btid_gap_report.bind(this,this.state.tableHeaders,this.state.tableBody)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {this.state.is_exp_button ?
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadLiveTraReportCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>:null }
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="LiveTraDumpTable" className="table table-striped table-hover">

                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(BtidGapReport)